import { ButtonHTMLAttributes } from 'react';
import cls from 'classnames';

import Icon from '@/common/components/Icon/Icon';
import { IconName } from '@/common/components/Icon/iconName';

import styles from './PinNavButton.module.css';

interface PinNavButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  icon: IconName;
  iconClassName?: string;
}

function PinNavButton({ icon, iconClassName, className, type = 'button', ...rest }: PinNavButtonProps) {
  return (
    <button className={cls(styles.pinNavButton, className)} type={type} {...rest}>
      <Icon className={cls(styles.pinNavButtonIcon, iconClassName)} name={icon} />
    </button>
  );
}

export default PinNavButton;
